module.exports = __webpack_public_path__ + "static/img/changyue-bg.cd9c0496.png";